import Model from "./base/model";

class SimulationQuoteAddress extends Model {
  resourceName() {
    return "simulation_quotes_addresses";
  }

  fields() {
    return {
      simulation_quote_id: "",
      address_id: "",
      type: "",
      address: ""
    };
  }

}

export default new SimulationQuoteAddress();
